import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import LocationCityIcon from '@material-ui/icons/LocationCity';

export const gasCityPlugin = createFrontendPlugin({
  pluginId: 'gas-city',
  title: 'Cities',
  icon: <LocationCityIcon />,
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/cities',
        title: 'Cities',
        icon: <LocationCityIcon />,
        loader: async () =>
          import('./CitiesPage').then(module => <module.CitiesPage />),
      },
    }),
  ],
});
